import React, { useEffect, useState } from "react";
import { Card, Badge, Button, Row, Col } from "react-bootstrap";

import ach from "../../assets/BugBountyImages/achivement.png";
import flash from "../../assets/BugBountyImages/flash.png";
import ENDPOINT from "../../data/ENDPOINT";
import { Alert, Avatar, } from "@mui/material";
import { Link } from "react-router-dom/cjs/react-router-dom";
import axios from "axios";
import SecurityHeaders from "../../data/SecurityHeaders";

function MentorsPage() {
  const [mentors, setMentors] = useState([]);




  const mentor = async () => {

    const data = new FormData()

    const res = await axios.get(ENDPOINT + "fetch-mentors.php", data, SecurityHeaders)

    if (res) {
      console.log(res.data.mentors)
      setMentors(res.data.mentors)
    }

  }

  useEffect(() => {
    mentor()
  }, [])



  return (

    <>
      <div className="w-100 bg-black">
        <div className='py-4 container '>
          <Alert severity="error">This page is under maintenance and will be fully functional from 7th Apr 2025. Kindly visit after 7th to access mentors.</Alert>

        </div>
      </div>

      <div className='bg-black   d-flex flex-wrap  '>
        <div className="container d-flex p-0 py-3">

          <div className='col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 container p-0'>

            <h2 className='text-white '>
              Get Mentorship From Our Top Mentors &
              Get employed by renowned MNC's
            </h2>

            <p className='text-light'>
              Explore exciting career opening at industry-leading satrtups known for inovation and growth. join a dynamic team and be a part of ground breaking
            </p>

            <div className='d-flex flex-wrap'>
              <div className='col-6 py-2 px-1'>
                <div className='bg-white rounded-3  d-flex p-2'>

                  <div>

                  </div>

                  <div>
                    <p className='fw-bold fs-5 p-0 m-0'>Cyber Security</p>
                    <small>128+ mentors avalible</small>
                  </div>
                </div>
              </div>

              <div className='col-6 py-2 px-1'>
                <div className='bg-white rounded-3  d-flex p-2'>

                  <div>

                  </div>

                  <div>
                    <p className='fw-bold fs-5 p-0 m-0'>Software Development</p>
                    <small>92+ mentors avalible</small>
                  </div>
                </div>
              </div>


              <div className='col-6 py-2 px-1'>
                <div className='bg-white rounded-3  d-flex p-2'>

                  <div>

                  </div>

                  <div>
                    <p className='fw-bold fs-5 p-0 m-0'>Data Science</p>
                    <small>62+ mentors avalible</small>
                  </div>
                </div>
              </div>


              <div className='col-6 py-2 px-1'>
                <div className='bg-white rounded-3  d-flex p-2'>

                  <div className='my-auto'>

                  </div>

                  <div>
                    <p className='fw-bold fs-5 p-0 m-0'>Human Resource</p>
                    <small>70+ mentors avalible</small>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <div className='col-xl-6 col-lg-7 col-md-7 col-sm-12 col-12 container p-0'>
            <div className='p-4 d-flex justify-content-center rounded-4'>
              <img className='w-100 rounded-4' src="https://skillsuprise.com/assets/mnc.jpg" />
            </div>
          </div>
        </div>

      </div>


      {/* six div */}


      <div className="container mt-5 pb-5 mb-5">
        <div className="text-center">
          <h2>Get Mentorship From Our Top Mentors</h2>

        </div>

        <Row className="mt-3">
          {mentors.length > 0 ? (
            mentors.map((mentor, index) => (
              <Col key={index} lg={3} md={3} sm={6} className="mb-4">
                <Card className="text-center shadow-sm position-relative card-container">
                  <div className="card-header-bg">
                    <div className="d-flex justify-content-between align-items-center p-3">
                      <p className="text-white border border-0 rounded-5 bg-black txt p-1">
                        <img src={flash} className="heii mb-1 me-1" alt="Flash Icon" /> Available
                      </p>
                      <img src={ach} className="hei bg-white rounded-5 p-1" alt="Achievement" />
                    </div>
                  </div>
                  <img src={mentor.profile_pic} className="profile-img" />
                  <Card.Body className="card-body-content mt-4">
                    <div className="d-flex justify-content-center  align-items-center">
                      <Card.Title className="m-0 p-0 " >{mentor.first_name} {mentor.last_name}</Card.Title>
                      <Badge bg="" className="ms-2 text-black">⭐ {mentor.ratings}</Badge>
                    </div>
                    <Card.Text className="text">{mentor.bio}</Card.Text>
                  </Card.Body>
                  <Card.Footer className="bg-white border-0 mb-3">
                    {/* <Link to={`/mentor/${mentor.mentor_id}`} className="rounded-pill bg-white border border-2 text-black px-3 py-1 text-decoration-none">
                      View Profile
                    </Link> */}
                  </Card.Footer>
                </Card>
              </Col>
            ))
          ) : (
            <p className="text-center mt-3">No mentors available.</p>
          )}
        </Row>
      </div>
    </>

  );
}

export default MentorsPage;
